import {SchemaProps} from "./JsonLdSchemaRouter";
import {
    canocicalUrl,
    context,
    creationDate,
    modificationDate,
    pictureUri,
    publicationAuthor,
    publicationEditor,
    publicationOrderInfo,
    publicationPublisher,
    publicationTitle,
    type_book
} from "./JsonLdUtil";

export function getPublicationSchema(props: SchemaProps) {
    const url = canocicalUrl(props);
    const name = publicationTitle(props);

    const editor = publicationEditor(props);
    const author = publicationAuthor(props);
    const publisher = publicationPublisher();
    const orderInfo = publicationOrderInfo(props);

    return {
        "@context": context,
        "@type": type_book,
        "@id": url,
        "url": url,
        "image": pictureUri(props),
        "name": name,
        "inLanguage": "de",
        ...editor,
        ...publisher,
        ...author,
        ...orderInfo,
        "datePublished": creationDate(props),
        "dateModified": modificationDate(props)
    }
}
